// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Ma8Wb","inputWrap":"styles_inputWrap__1BJKw","input":"styles_input__1trau"};